import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { GraduationCap } from "lucide-react";

const PERIODS = [["30", "30 gg"], ["90", "90 gg"], ["365", "12 mesi"]];
const fmtDate = (d) => (d ? new Date(d + "T00:00:00").toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export default function AthleteLessonsCard({ athleteId }) {
  const [days, setDays] = useState("90");
  const [d, setD] = useState(null);

  useEffect(() => {
    const from = new Date(Date.now() - parseInt(days) * 864e5).toISOString().slice(0, 10);
    api.get(`/athletes/${athleteId}/lessons-summary`, { params: { from } }).then((r) => setD(r.data)).catch(() => setD(null));
  }, [athleteId, days]);

  const stale = d?.days_since_last == null || d.days_since_last > 30;

  return (
    <div className="bg-white border border-zinc-200 rounded-md p-5" data-testid="athlete-lessons-card">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
        <h2 className="font-heading font-semibold flex items-center gap-2"><GraduationCap className="w-4 h-4" />Lezioni individuali</h2>
        <div className="flex items-center gap-2">
          <div className="flex border border-zinc-200 rounded overflow-hidden">
            {PERIODS.map(([v, l]) => <button key={v} data-testid={`lessons-period-${v}`} onClick={() => setDays(v)} className={`px-2.5 py-1 text-xs ${days === v ? "bg-black text-white" : "hover:bg-zinc-50"}`}>{l}</button>)}
          </div>
          <Link to={`/scherma?tab=lessons-archive&athlete=${athleteId}`} className="text-xs uppercase tracking-wider text-[#0052FF] hover:underline" data-testid="lessons-archive-link">Archivio →</Link>
        </div>
      </div>
      {!d ? <div className="text-sm text-zinc-500">Caricamento…</div> : (
        <>
          <div className="grid grid-cols-3 gap-3 mb-3">
            <div><div className="text-[10px] uppercase tracking-wider text-zinc-500">Lezioni</div><div className="font-heading text-2xl font-bold" data-testid="lessons-total">{d.total}</div></div>
            <div><div className="text-[10px] uppercase tracking-wider text-zinc-500">Minuti</div><div className="font-heading text-2xl font-bold">{d.minutes}</div></div>
            <div>
              <div className="text-[10px] uppercase tracking-wider text-zinc-500">Ultima lezione</div>
              <div className={`font-heading text-base font-bold ${stale ? "text-amber-700" : ""}`} data-testid="lessons-last">{fmtDate(d.last_lesson_date)}</div>
              <div className="text-[10px] text-zinc-500 font-mono">{d.days_since_last == null ? "mai registrata" : `${d.days_since_last} gg fa`}{stale && d.last_lesson_date ? " · scoperto >30gg" : ""}</div>
            </div>
          </div>
          {d.by_coach.length > 0 ? (
            <div className="space-y-1.5" data-testid="lessons-by-coach">
              {d.by_coach.map((c) => (
                <div key={c.coach_id || "none"} className="flex items-center justify-between text-sm border border-zinc-100 rounded px-3 py-2">
                  <span className="font-medium">{c.name}</span>
                  <span className="font-mono text-xs text-zinc-600"><strong className="text-base text-zinc-900">{c.lessons}</strong> lezioni · {c.minutes}′ · ultima {c.last_date}</span>
                </div>
              ))}
            </div>
          ) : <div className="text-sm text-zinc-500">Nessuna lezione nel periodo.</div>}
        </>
      )}
    </div>
  );
}
